import { createStore } from 'vuex'

import buildComms from './comms'
import modules from './comms-modules'
import remarkTags from './remark-tags'

export default function createCommsStore(endpointParams, initialData = {}) {
  const { state, getters, mutations, actions } = buildComms(
    endpointParams,
    initialData
  )
  // main comms logic - need it at root-level in the store, not as a submodule
  // it's abstracted away in a shared file with other stores
  const store = createStore({
    modules,
    state,
    getters,
    mutations,
    actions,
  })

  store.registerModule('remarkTags', remarkTags, { preserveState: true })

  return store
}
